import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import DateFnsUtils from '@date-io/date-fns';
import * as moment from "moment";
import { MuiPickersUtilsProvider, KeyboardDatePicker, } from '@material-ui/pickers';

export default ({ name, minDOBirth, maxDOBirth, value, inputValue, callBackFun, disabled, type }) => {

  return (
    <div>
      <div className='custom-date-piker'>
        <div
          className={`file-input-wrapper ${disabled ? 'disabled-datepicker' : ''}`}
        >
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              minDate={minDOBirth}
              maxDate={maxDOBirth}
              disabled={disabled ? disabled : false}
              name={name}
              margin="normal"
              id="date-picker-dialog"
              format="MM/dd/yyyy"
              placeholder="MM/DD/YYYY"
              value={value}
              inputValue={inputValue}
              InputProps={{ readOnly: type === "DatesDisabled" ? true : false }}

              onChange={(date, value) => {
                if (type === 'returnNormalDate') {
                  return callBackFun(date)
                } else if (name === 'fromDateOrderFilter' || name === 'toDateOrderFilter') {
                  return callBackFun(moment(date).format('MM/DD/YYYY'));
                } else if (name === 'fromDatePTOrderReport' || name === "toDatePTOrderReport" || name === 'fromDateGetQuote' || name === 'toDateGetQuote' || name === 'fromDatePtplusOrderReq' || name === 'toDatePtplusOrderReq' || name === 'fromDatePosts' || name === 'toDatePosts' || name === 'fromDatePostModule' || name === 'toDatePostModule' || name === 'toDateCancelOrders' || name === 'fromDateCancelOrders' || name === 'toDatePurchaseReport' || name === 'fromDatePurchaseReport' || name === 'toDateOtherReports' || name === 'fromDateOtherReports' || name === 'toDateRetryOrders' || name === 'fromDateRetryOrders' || name === 'fromDatePTAdjInvoice' || name === 'toDatePTAdjInvoice' || name === 'fromDatePtPlusInvoice' || name === 'toDatePtPlusInvoice') {
                  return callBackFun(date, value);
                } else if (type === 'flatFeeForm' || type === 'buyBackFeeForm' || name === 'fromDateBuyBackFeeFilter' || name === 'toDateBuyBackFeeFilter') {
                  return callBackFun(date, value);
                } else {
                  let offsetTime = new Date().getTimezoneOffset()
                  var newDate = new Date(date.getTime() + (offsetTime * 60 * 1000));
                  return callBackFun(newDate);
                }
              }}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
            />

          </MuiPickersUtilsProvider>

        </div>
      </div>
    </div>
  );
};
